import { render, staticRenderFns } from "./ImportacaoUpload.vue?vue&type=template&id=053e51ca&scoped=true"
import script from "./ImportacaoUpload.vue?vue&type=script&lang=js"
export * from "./ImportacaoUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e51ca",
  null
  
)

export default component.exports